import Image from "next/legacy/image"
import Block from "@/components/wrappers/block"
import styles from "./textImageBlock.module.css"
import cx from "classnames"

export default function TextImageBlock({
  block,
  image,
  layout,
  children,
  hovered = false,
  plateColor,
  padding = true
}) {
  return (
    <Block
      block={block}
      width="full"
      className={cx(styles.wrapper, styles["layout-" + layout])}>
      <div
        className={cx(
          styles.innerWrapper,
          {
            "no-padding": !padding
          },
          plateColor
        )}>
        <div
          className={cx(styles.contentGrid, {
            noImage: !image?.url
          })}>
          {image?.url && (
            <div className={styles.imageHolder}>
              <figure
                className={cx(
                  styles.figure,
                  hovered ? "image-hover-effect" : ""
                )}>
                {image?.url && (
                  <Image
                    className={styles.image}
                    src={image.url}
                    sizes={image.sizes}
                    alt={image.alt}
                    layout="fill"
                    loading="lazy"
                  />
                )}
              </figure>
            </div>
          )}
          <div
            className={cx(styles.contentWrapper, {
              "no-padding": !padding
            })}>
            {children}
          </div>
        </div>
      </div>
    </Block>
  )
}
